export const ID = 'b71160bf-8079-4016-b2ed-e41345baa19c';

export const NAME = 'Promo Banner';

export const RIBBON = 'RIBBON';
export const FULLWIDTH = 'FULLWIDTH';
